import { Button } from "@/components/ui/button";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import Section from "@/features/website/components/Section";
import SectionTitle from "@/features/website/components/SectionTitle";
import { useForm as formspree } from "@formspree/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import * as z from "zod";

const FormSchema = z.object({
	email: z
		.string()
		.min(1, { message: "This field has to be filled." })
		.email("This is not a valid email."),
});

const Waitlist = () => {
	const form = useForm<z.infer<typeof FormSchema>>({
		resolver: zodResolver(FormSchema),
	});

	const [state, handleSubmit] = formspree("manojyoe");

	if (state.succeeded) {
		return (
			<Section>
				<SectionTitle
					left={true}
					title="Thank You for Joining Our Waitlist"
					caption="Successfully Joined"
					description="We'll notify you when Patient Watch is ready for you to try."
				/>
			</Section>
		);
	}

	function onSubmit(values: z.infer<typeof FormSchema>) {
		handleSubmit(values);
	}

	return (
		<Section className="md-width">
			<SectionTitle
				left={true}
				caption="Register your Interest"
				title="Be Among the First to Experience Patient Watch"
				description="Save follow-up appointments, automate your audit and streamline PROMs and consent"
			/>
			<div className="flex justify-center w-full">
				<Form {...form}>
					<form
						onSubmit={form.handleSubmit(onSubmit)}
						className="space-y-6 w-full max-w-md text-lg"
					>
						<FormField
							control={form.control}
							name="email"
							render={({ field }) => (
								<FormItem>
									<FormLabel>Email</FormLabel>
									<FormControl>
										<Input placeholder="e.g. joe@example.com" {...field} />
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
						<Button type="submit" className="w-full">
							{state.submitting ? "Joining..." : "Join Waitlist"}
						</Button>
					</form>
				</Form>
			</div>
		</Section>
	);
};

export const Route = createFileRoute("/_website/waitlist")({
	component: Waitlist,
});
